module.exports = __webpack_public_path__ + "img/cleanup7-7-8-2021.59e986b1.jpg";